export default "__VITE_ASSET__BAhfi5_Q__"